import React from 'react';
import Banner from '../components/Banner';
import Navigation from '../components/navigation2';
import Footer from '../components/Footer';
import '../styles/pages/protection.css';

const protection = () => {
    return (
        <div>
            <Banner />
            <Navigation />
            <h1 className='protection_titre'>Politique de Protection des Données</h1>
            <p className='protection_texte'>La protection de vos données personnelles est une priorité pour nous. Nous nous engageons à respecter votre vie privée et à protéger vos informations.</p>
            <p className='protection_texte'>Nous collectons des données personnelles lorsque vous utilisez notre site, notamment lors de la soumission d'un formulaire.</p>
            <p className='protection_texte'>Ces données sont utilisées pour vous fournir nos services, améliorer votre expérience et communiquer avec vous.</p>
            <p className='protection_texte'>Nous ne partageons pas vos données avec des tiers sans votre consentement, sauf si la loi l'exige.</p>
            <p className='protection_texte'>Vous avez le droit d'accéder à vos données, de les rectifier ou de demander leur suppression à tout moment.</p>
            <Footer />
        </div>
    );
};

export default protection;